import { useState } from "react";
import { ethers } from "ethers";
import marketplaceAbi from "../abis/NFTMarketplace.json";
import nftAbi from "../abis/RockNFT.json";

const MARKETPLACE_ADDRESS = "0x0cCC053bA17A822e073A8F4c057a23922ee0B161";
const NFT_ADDRESS = "0x35270c78593AB2b6BE570CA02e10EbDBDe0Fd80a";

function ListNFTForm({ signer }) {
  const [tokenId, setTokenId] = useState("");
  const [startPrice, setStartPrice] = useState("");
  const [buyNowPrice, setBuyNowPrice] = useState("");

  const handleApprove = async () => {
    try {
      const nft = new ethers.Contract(NFT_ADDRESS, nftAbi.abi, signer);
      await nft.setApprovalForAll(MARKETPLACE_ADDRESS, true);
      alert("✅ Marketplace 사용 승인 완료!");
    } catch (error) {
      console.error(error);
      alert("❌ 승인 실패: " + error.message);
    }
  };

  const handleList = async () => {
    try {
      const marketplace = new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, signer);

      const start = ethers.parseEther(startPrice);
      const buyNow = ethers.parseEther(buyNowPrice);
      const deadline = Math.floor(Date.now() / 1000) + 60 * 15; // 15분

      await marketplace.listNFT(NFT_ADDRESS, tokenId, start, buyNow, deadline);

      alert("✅ NFT 등록 성공!");
    } catch (error) {
      console.error(error);
      alert("❌ 등록 실패: " + error.message);
    }
  };

  return (
    <div className="component-card">
      <h3 style={{ textAlign: 'center', marginBottom: 16 }}>판매 등록</h3>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <button className="component-btn" onClick={handleApprove} style={{ marginBottom: "10px" }}>
          Marketplace 사용 승인
        </button>
      </div>
      <form style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }} onSubmit={e => { e.preventDefault(); handleList(); }}>
        <input
          className="component-input"
          type="number"
          placeholder="Token ID"
          value={tokenId}
          onChange={(e) => setTokenId(e.target.value)}
        />
        <input
          className="component-input"
          type="text"
          placeholder="최소 입찰가 (KAIA)"
          value={startPrice}
          onChange={(e) => setStartPrice(e.target.value)}
        />
        <input
          className="component-input"
          type="text"
          placeholder="즉시 구매가 (KAIA)"
          value={buyNowPrice}
          onChange={(e) => setBuyNowPrice(e.target.value)}
        />
        <button className="component-btn" type="submit">등록</button>
      </form>
    </div>
  );
}

export default ListNFTForm;
